import { memo } from "react";
import { PhotoCell } from "./PhotoCell";

const AREAS = ["a", "b", "c", "d"];

export const BookPage = memo(({ page, selecting, selected, onOpen, onToggle }) => (
  <div className={`book-page layout-${page.layout}`} data-testid={`book-page-${page.key}`}>
    {page.items.map((it, idx) => (
      <PhotoCell
        key={it.id}
        item={it}
        area={AREAS[idx]}
        selecting={selecting}
        selected={selected?.has(it.id)}
        onOpen={onOpen}
        onToggle={onToggle}
      />
    ))}
  </div>
));
BookPage.displayName = "BookPage";

export const CoverPage = ({ title, coverUrl }) => (
  <div className="book-page book-cover" data-testid="album-cover-page">
    {coverUrl && <img src={coverUrl} alt="" />}
    <h1 className="book-cover-title" data-testid="album-cover-title">{title}</h1>
  </div>
);
